import React from 'react';
//import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import './Footer.scss';
import logo from '../../assets/images/logo-BG.svg';

/**
 * Site's footer
 * 
 * @component - Footer
 * @parentComponent - App
 */

const Footer = () => {

  const { t } = useTranslation();

  //Removes spaces and 1 digit(0) - for example: '0700 10876' -> '70010876'
  const formatPhone = (str: string) => str.replace(/\u00A0/g, '').substring(1);
  
  return(
        <div className="Footer">
            <Container>
                <Row>
                    <Col md={4} sm={12} className="logo-wrapper">
                        <img src={logo} className="site-logo" alt="BG Toll" />
                        <p className="address">бул. Македония №3 <br/> София, България</p>
                    </Col>
                    <Col md={4} sm={6} className="info-wrapper">
                        <h5 className="footer-heading">{t('Footer.publicInformation')}</h5>
                        <a href={"mailto:" + t('Footer.infoMail')}>
                            <FontAwesomeIcon icon={faEnvelope} />
                            {t('Footer.infoMail')}
                            </a>
                        <a href={"tel:00359" + formatPhone(t('Footer.phone')) }>
                            <FontAwesomeIcon icon={faPhone} />
                            {t('Footer.phone')}<br/>
                            <span className="cost">{t('(цена на разговор?)')}</span>
                        </a>
                    </Col>
                    <Col md={4} sm={6} className="press-wrapper">
                        <h5 className="footer-heading">{t('Footer.publicRelations')}</h5>
                        <a href={"mailto:" + t('Footer.pressMail')}>
                            <FontAwesomeIcon icon={faEnvelope} />
                            {t('Footer.pressMail')}
                        </a>
                    </Col>
                </Row>
                <Row className="footer-info-links">
                    {/* <Col md={{ span: 4, offset: 4 }} sm={6}>
                        <Link to="/payment" className="footer-heading">{t('Footer.paymentInfo')}</Link>
                    </Col> */}
                    <Col md={4} sm={6}>
                        <a href="https://www.bgtoll.bg/za-nas/obsi-uslovia" className="footer-heading">{t('Footer.terms')}</a>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Footer;
